import React from "react";
import { Icon } from "../../../core/Icon";
import { bytesToSize } from "../../../core/bytesToSize";
import { AppConfig } from "../../../app-state";
export const AttachedDocs = (props) => {
    return React.createElement("div", { className: "ed-docs" },
        React.createElement("h2", { className: "h4" }, "P\u0159ilo\u017Een\u00E9 dokumenty"),
        props.docData && props.docData.list.map((item) => {
            return React.createElement("div", { key: item.id, className: "item-row" },
                React.createElement("a", { target: "_blank", className: "name", href: AppConfig.filesPrefix + item.path }, item.filename),
                React.createElement("div", { className: "desc" },
                    item.status !== 'removal' && React.createElement("span", { className: "size" },
                        "Velikost: ",
                        bytesToSize(item.size)),
                    item.status == 'removal' && React.createElement("span", { className: "removal" }, "Ozna\u010Deno k odstran\u011Bn\u00ED")),
                React.createElement(Icon, { c: ['pdf', 32, 32, 'thumb-file'] }));
        }),
        props.docData.list && props.docData.list.length == 0 && React.createElement("div", { className: "text-muted" }, "\u017D\u00E1dn\u00E9 dokumenty"));
};
